import axios from 'axios';

/**
 * For use in Dispute Management. Deletes a supporting document from a disputes case files.
 */
export default function deleteFile({ invoiceNumber, documentId, retailerId }) {
  return axios.post(`api/shortagesdisputedocument/DeleteDocument`, { invoiceNumber, documentId, retailerId });
}
